module.exports = __webpack_public_path__ + "img/ico_moni.5ea47a2c.png";